const errorsMapping = {
    SOMETHING_WENT_WRONG: 'common.error.network',
    SUBSCRIPTION_NOT_FOUND: 'cancelSubscription.errors.notFound',
    SUBSCRIPTION_UNAUTHORIZED: 'cancelSubscription.errors.unauthorized',
    SUBSCRIPTION_INVALID_TERMINATION_DATE: 'cancelSubscription.errors.invalidTerminationDate',
    SUBSCRIPTION_INVALID_INPUT: 'cancelSubscription.errors.invalidTerminationInput'
};

export { errorsMapping };
//# sourceMappingURL=errors.js.map
